import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavMenu } from '@shopify/app-bridge-react';
import { Layout, Page } from '@shopify/polaris';
import { NavLink, Outlet } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGaugeHigh, faHeadset, faSliders } from '@fortawesome/free-solid-svg-icons';

const navItems = [
    { to: '/', label: 'Widgets list', icon: faGaugeHigh },
    { to: '/manage-widget', label: 'Manage widgets', icon: faSliders },
    { to: '/support', label: 'Support', icon: faHeadset },
];

export default function RootLayout() {
    return (
        <Page>
            <div className="mv-app-shell">
                <NavMenu>
                    <a href="/" rel="home">
                        Home
                    </a>
                    <a href="/manage-widget" rel="manage-widget">
                        Manage widgets
                    </a>
                    <a href="/support" rel="support">
                        Support
                    </a>
                </NavMenu>

                <ToastContainer pauseOnHover />

                <header className="mv-shell-top mv-reveal mv-reveal--quick">
                    <div className="mv-shell-brand">
                        <p className="mv-shell-eyebrow">Maxify Apps</p>
                        <h1 className="mv-shell-title">Sales Boost Studio</h1>
                        <p className="mv-shell-subtitle">
                            Build high-converting urgency widgets with polished visuals, precise targeting, and live
                            storefront preview.
                        </p>
                    </div>

                    <nav className="mv-shell-nav" aria-label="Admin navigation">
                        {navItems.map(item => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                className={({ isActive }) => `mv-shell-nav-link${isActive ? ' active' : ''}`}
                            >
                                <FontAwesomeIcon icon={item.icon} />
                                <span>{item.label}</span>
                            </NavLink>
                        ))}
                    </nav>
                </header>

                <Layout>
                    <Layout.Section>
                        <div className="mv-page-content">
                            <Outlet />
                        </div>
                    </Layout.Section>
                </Layout>
            </div>
        </Page>
    );
}
